import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../auth/Navbar'
import QueryErrorBoundary from '../common/QueryErrorBoundary'
import { LoadingSpinner } from '../ui/loading-spinner'

const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="container mx-auto px-4 py-8 flex-grow flex flex-col">
        <QueryErrorBoundary>
          <Suspense
            fallback={
              <div className="flex h-[50vh] items-center justify-center">
                <LoadingSpinner className="h-8 w-8" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </QueryErrorBoundary>
      </main>
    </div>
  )
}

export default MainLayout
